export const dashboardLoader = {
  mainDashboard: 'mainDashboard',
};

export const initialStateDashboard = {
  mainDashboard: true,
};
